import { render, staticRenderFns } from "./samples.vue?vue&type=template&id=a835f990&scoped=true&"
import script from "./samples.vue?vue&type=script&lang=js&"
export * from "./samples.vue?vue&type=script&lang=js&"
import style0 from "./samples.vue?vue&type=style&index=0&id=a835f990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a835f990",
  null
  
)

export default component.exports